<template>
  <b-card>
    <b-list-group>
      <b-list-group-item v-for="item in timetables" :key="'id' + item.id">
        <b-row style="cursor:pointer" v-b-toggle="'' + item.id">
          <b-col>{{ item.name }}</b-col>
          <b-col>Łączny czas pracy w tygodniu: {{ calcTime(item) }}</b-col>
          <b-col>
            <b-dropdown size="sm" split @click="editTimetable(item)" text="Edytuj" variant="outline-primary" class="float-right">
              <b-dropdown-item @click="deleteTimetable(item.id)">Usuń</b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-collapse :id="'' + item.id">
          <b-row class="pt-2">
            <b-col>Poniedziałek</b-col>
            <b-col>Wtorek</b-col>
            <b-col>Środa</b-col>
            <b-col>Czwartek</b-col>
            <b-col>Piątek</b-col>
            <b-col>Sobota</b-col>
            <b-col>Niedziela</b-col>
          </b-row>
          <b-row>
            <b-col>
              <span v-if="item.monday">{{ calcStart(item.monday) }}-{{ calcEnd(item.monday, item.monTime) }}</span>
            </b-col>
            <b-col>
              <span v-if="item.tuesday">{{ calcStart(item.tuesday) }}-{{ calcEnd(item.tuesday, item.tueTime) }}</span>
            </b-col>
            <b-col>
              <span v-if="item.wednesday">{{ calcStart(item.wednesday) }}-{{ calcEnd(item.wednesday, item.wedTime) }}</span>
            </b-col>
            <b-col>
              <span v-if="item.thursday">{{ calcStart(item.thursday) }}-{{ calcEnd(item.thursday, item.thuTime) }}</span>
            </b-col>
            <b-col>
              <span v-if="item.friday">{{ calcStart(item.friday) }}-{{ calcEnd(item.friday, item.friTime) }}</span>
            </b-col>
            <b-col>
              <span v-if="item.saturday">{{ calcStart(item.saturday) }}-{{ calcEnd(item.saturday, item.satTime) }}</span>
            </b-col>
            <b-col>
              <span v-if="item.sunday">{{ calcStart(item.sunday) }}-{{ calcEnd(item.sunday, item.sunTime) }}</span>
            </b-col>
          </b-row>
        </b-collapse>
      </b-list-group-item>
    </b-list-group>
    <b-btn size="sm" class="float-right mt-3" @click="addTimetable" variant="outline-primary">Dodaj</b-btn>
    <add-modal @created="showCreated" @updated="showUpdated" @hide="onHideModal" :show="showModal" :toEdit="selectedTimetable"></add-modal>
  </b-card>
</template>

<script>
import AddModal from './AddModal.vue';
import { TimetableResource } from '@/resources/timetable.resource';
export default {
  components: { AddModal },
  data() {
    return {
      showModal: false,
      timetables: [],
      selectedTimetable: undefined
    };
  },
  methods: {
    addTimetable() {
      this.showModal = true;
    },
    onHideModal() {
      this.showModal = false;
      this.selectedTimetable = undefined;
    },
    async getTimetables() {
      try {
        const data = await TimetableResource.get();
        this.timetables.push(...data.timetables);
      } catch (error) {
        this.$notify({ text: 'Wystąpił błąd podczas pobierania harmonogramów', title: 'Błąd!', type: 'error' });
        console.warn(error);
      }
    },
    editTimetable(item) {
      this.selectedTimetable = item;
      this.showModal = true;
    },
    async deleteTimetable(id) {
      try {
        const data = await TimetableResource.delete(id);
        this.timetables.splice(this.timetables.findIndex(item => item.id === id), 1);
      } catch (error) {
        console.warn(error);
      }
    },
    calcTime(item) {
      return (item.monTime + item.tueTime + item.wedTime + item.thuTime + item.friTime + item.satTime + item.sunTime) / 60 + ' godz.';
    },
    calcStart(time) {
      const h = Math.floor(time / 60);
      const m = parseInt(time % 60, 10);
      const hh = h < 10 ? '0' + h : h;
      const mm = m < 10 ? '0' + m : m;
      return hh + ':' + mm;
    },
    calcEnd(start, time) {
      const h = Math.floor((start + time) / 60);
      const m = parseInt((start + time) % 60, 10);
      const hh = h < 10 ? '0' + h : h;
      const mm = m < 10 ? '0' + m : m;
      return hh + ':' + mm;
    },
    showCreated(item) {
      this.timetables.push(item.timetableCreate);
    },
    showUpdated(data) {
      const index = this.timetables.map(i => i.id).indexOf(data.id);

      this.timetables.splice(index, 1, data);
    }
  },
  mounted() {
    this.getTimetables();
  }
};
</script>
